import Vue from 'vue';
import Router from 'vue-router';

import Home from '@/views/Dashboard/Home.vue';
import DefaultLayout from '@/views/Layout.vue';

import store from './store';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      components: {
        default: Home,
      },
    },
    {
      path: '/user',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'user.index',
          component: () => import(/* webpackChunkName: "userIndex" */ '../views/User/Index.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Users', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'user.create',
          component: () => import(/* webpackChunkName: "userCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create User',
            form: 'CreateUserForm',
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Users', exact: true, to: { name: 'user.index' } },
              { text: 'Create User', disabled: true },
            ],
          },
        },
        {
          path: 'me',
          name: 'user.me',
          component: () => import(/* webpackChunkName: "userCurrent" */ '../views/User/Profile.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Users', exact: true, to: { name: 'user.index' } },
              { text: 'My Profile', disabled: true },
            ],
            allowUnconfirmed: true,
          },
        },
        {
          path: ':id',
          name: 'user.read',
          component: () => import(/* webpackChunkName: "userProfile" */ '../views/User/Profile.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Users', exact: true, to: { name: 'user.index' } },
              { text: 'View Profile', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/provider',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'provider.index',
          component: () => import(/* webpackChunkName: "providerIndex" */ '../views/Provider/Index.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Providers', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'provider.create',
          component: () => import(/* webpackChunkName: "providerCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Provider',
            form: 'ProviderForm',
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Providers', exact: true, to: { name: 'provider.index' } },
              { text: 'Create Provider', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'provider.update',
          component: () => import(/* webpackChunkName: "providerUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Edit Provider Profile',
            form: 'ProviderForm',
            api: (route) => ({
              api: `provider/${route.params.id}`,
            }),
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Providers', exact: true, to: { name: 'provider.index' } },
              { text: 'Update Provider', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/location',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'location.index',
          component: () => import(/* webpackChunkName: "locationIndex" */ '../views/Location/Index.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Locations', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'location.create',
          component: () => import(/* webpackChunkName: "locationCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Location',
            form: 'LocationForm',
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Locations', exact: true, to: { name: 'location.index' } },
              { text: 'Create Location', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'location.update',
          component: () => import(/* webpackChunkName: "locationUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Location',
            form: 'LocationForm',
            api: (route) => ({
              api: `location/${route.params.id}`,
            }),
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Locations', exact: true, to: { name: 'location.index' } },
              { text: 'Update Location', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/media',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'media.index',
          component: () => import(/* webpackChunkName: "mediaIndex" */ '../views/Media/Index.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Media', disabled: true },
            ],
          },
        },
        {
          path: ':directory',
          name: 'media.directory',
          component: () => import(/* webpackChunkName: "mediaDirectory" */ '../views/Media/Directory.vue'),
          props: true,
          meta: {
            breadcrumbs: (route) => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Media', exact: true, to: { name: 'media.index' } },
              { text: `${route.params.directory} Directory`, disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/place',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'place.index',
          component: () => import(/* webpackChunkName: "placeIndex" */ '../views/Place/Index.vue'),
          meta: {
            role: 'Editor',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Places', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'place.create',
          component: () => import(/* webpackChunkName: "placeCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Place',
            form: 'PlaceForm',
          },
          meta: {
            role: 'Editor',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Places', exact: true, to: { name: 'place.index' } },
              { text: 'Create Place', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'place.update',
          component: () => import(/* webpackChunkName: "placeUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Place',
            form: 'PlaceForm',
            api: (route) => ({
              api: `Place/${route.params.id}`,
            }),
          },
          meta: {
            role: 'Editor',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Places', exact: true, to: { name: 'place.index' } },
              { text: 'Update Place', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/schedule',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'schedule.index',
          component: () => import(/* webpackChunkName: "scheduleIndex" */ '../views/Schedule/Index.vue'),
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Schedules', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'schedule.create',
          component: () => import(/* webpackChunkName: "scheduleCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Schedule',
            form: 'ScheduleForm',
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Schedules', exact: true, to: { name: 'schedule.index' } },
              { text: 'Create Schedule', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'schedule.update',
          component: () => import(/* webpackChunkName: "scheduleUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Schedule',
            form: 'ScheduleForm',
            api: (route) => ({
              api: `Schedule/${route.params.id}`,
            }),
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Schedules', exact: true, to: { name: 'schedule.index' } },
              { text: 'Update Schedule', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/holiday',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'day.index',
          component: () => import(/* webpackChunkName: "dayIndex" */ '../views/Day/Index.vue'),
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Holidays', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'day.create',
          component: () => import(/* webpackChunkName: "dayCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Holiday',
            form: 'DayForm',
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Holidays', exact: true, to: { name: 'day.index' } },
              { text: 'Create Holiday', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'day.update',
          component: () => import(/* webpackChunkName: "dayUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Holiday',
            form: 'DayForm',
            api: (route) => ({
              api: `Day/${route.params.id}`,
            }),
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Holidays', exact: true, to: { name: 'day.index' } },
              { text: 'Update Holiday', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/country',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'country.index',
          component: () => import(/* webpackChunkName: "countryIndex" */ '../views/Country/Index.vue'),
          meta: {
            role: 'Editor',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Countries', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'country.create',
          component: () => import(/* webpackChunkName: "countryCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Country',
            form: 'CountryForm',
          },
          meta: {
            role: 'Admin',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Countries', exact: true, to: { name: 'country.index' } },
              { text: 'Create Country', disabled: true },
            ],
          },
        },
        {
          path: ':code',
          name: 'country.update',
          component: () => import(/* webpackChunkName: "countryUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Country',
            form: 'CountryForm',
            api: (route) => ({
              api: `Country/${route.params.code}`,
            }),
          },
          meta: {
            role: 'Editor',
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Countries', exact: true, to: { name: 'country.index' } },
              { text: 'Update Country', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/tag',
      components: {
        default: DefaultLayout,
      },
      children: [
        {
          path: '/',
          name: 'tag.index',
          component: () => import(/* webpackChunkName: "tagIndex" */ '../views/Tag/Index.vue'),
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Tags', disabled: true },
            ],
          },
        },
        {
          path: 'new',
          name: 'tag.create',
          component: () => import(/* webpackChunkName: "tagCreate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Create Tag',
            form: 'TagForm',
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Tags', exact: true, to: { name: 'tag.index' } },
              { text: 'Create Tag', disabled: true },
            ],
          },
        },
        {
          path: ':id',
          name: 'tag.update',
          component: () => import(/* webpackChunkName: "tagUpdate" */ '../views/CrudForm.vue'),
          props: {
            heading: 'Update Tag',
            form: 'TagForm',
            api: (route) => ({
              api: `Tag/${route.params.id}`,
            }),
          },
          meta: {
            breadcrumbs: () => [
              { text: 'Home', exact: true, to: { name: 'home' } },
              { text: 'Tags', exact: true, to: { name: 'tag.index' } },
              { text: 'Update Tag', disabled: true },
            ],
          },
        },
      ],
    },
    {
      path: '/user/:id/recover',
      name: 'user.recover',
      component: () => import(/* webpackChunkName: "userRecover" */ '../views/User/Recover.vue'),
      props: (route) => ({ code: route.query.code, id: route.params.id }),
      meta: {
        auth: false,
        nav: false,
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: "login" */ '../views/NavlessForm.vue'),
      props: {
        form: 'LoginForm',
      },
      meta: {
        auth: false,
        nav: false,
      },
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () => import(/* webpackChunkName: "forgot" */ '../views/NavlessForm.vue'),
      props: {
        form: 'ForgotForm',
      },
      meta: {
        auth: false,
        nav: false,
      },
    },
  ],
});

// Global Guards
router.beforeEach((to, from, next) => {
  // If the current route requires authentication
  if (to.matched.some((record) => record.meta.auth !== false)) {
    if (!store.getters.isLogged || store.getters.isExpired) {
      // If the user is not logged in or the token is expired, log the user out
      store.dispatch('logout');
      next({
        name: 'login',
        query: { redirect: to.fullPath },
      });
    } else if (!store.getters.isConfirmed && to.meta.allowUnconfirmed !== true) {
      // If the user is not confirmed and the route does not allow unconfirmed access
      next({
        name: 'user.me',
        query: { error: 'unconfirmed' },
      });
    } else if (to.meta.role && !store.getters.can(to.meta.role)) {
      // If the user does not have the permissions needed
      next({
        path: from.path,
        query: { error: 'unauthorized' },
      });
    } else {
      // The user is allowed if none of the above is true
      next();
    }
  } else {
    // This is a public route
    next();
  }
});

export default router;
